import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { AppLayer, LayerService } from 'app/services/layer.service';
import { MainDataService, SchemaDefinedBy } from 'app/services/main-data.service';

interface LayerExt extends AppLayer {
	isSelected?: boolean;
}
@Component({
  selector: 'app-modal-download-layers',
  templateUrl: './modal-download-layers.component.html',
  styleUrls: ['./modal-download-layers.component.css']
})
export class ModalDownloadLayersComponent implements OnInit {

	layers: LayerExt[];

	isCheckAll: boolean;

	schemaDefinedByList: SchemaDefinedBy[];
	selectedSchema: SchemaDefinedBy;

	constructor(
		private dialogRef: MatDialogRef<ModalDownloadLayersComponent>,
		private layerService: LayerService,
		private mainDataService: MainDataService
	) { }

	onTggleCheckAll() {
		this.layers.forEach(l => l.isSelected = this.isCheckAll);
	}

	cancel() {
		this.dialogRef.close();
	}
	download() {
		const layers = this.layers.filter(l => l.isSelected).map(l => {
			return {
				layerId: l.id,
				schema: this.selectedSchema.value
			}
		});
		this.dialogRef.close({
			layers: layers
		});
	}
	checkDisableDownload() {
		return !this.layers.filter(l => l.isSelected).length;
	}
	ngOnInit() {
		this.layers = this.layerService.layerListBS.getValue().layers.filter(l => l.state.num >= 1).map(l => Object.assign({}, l));
		
		this.schemaDefinedByList = this.mainDataService.getSchemaDefinedBy();
		this.selectedSchema = this.schemaDefinedByList[0];
	}

}
